module.exports = __webpack_public_path__ + "img/V130.66c1e162.png";